import { Box, Typography } from '@mui/material';
import { Search as SearchIcon, Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { AppButton } from '@/shared/components';

interface QuickActionButtonProps {
  variant: 'search' | 'publish';
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

function QuickActionButton({ variant, icon, label, onClick }: QuickActionButtonProps) {
  const isSearch = variant === 'search';

  return (
    <AppButton
      onClick={onClick}
      variant={isSearch ? 'primary' : 'secondary'}
      sx={{
        flex: 1,
        minHeight: 82,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 0.75,
        padding: 1,
        boxShadow: 4,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 4,
        },
        '&:active': {
          transform: 'translateY(0)',
        },
        '&:focus-visible': {
          outline: '3px solid',
          outlineColor: isSearch ? 'primary.light' : 'secondary.dark',
          outlineOffset: 2,
        },
      }}
    >
      <Box
        sx={{
          fontSize: 26,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon}
      </Box>
      <Typography
        variant="subtitle1"
        component="span"
        sx={{
          fontWeight: 600,
          textTransform: 'none',
          fontSize: { xs: '0.85rem', sm: '0.9rem' },
          lineHeight: 1.1,
          color: 'inherit',
        }}
      >
        {label}
      </Typography>
    </AppButton>
  );
}

export function QuickActions() {
  const navigate = useNavigate();

  const handleSearchClick = () => {
    navigate('/search');
  };

  const handlePublishClick = () => {
    navigate('/publish');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        mb: 3,
        width: '100%',
        maxWidth: 600,
        mx: 'auto',
      }}
    >
      <QuickActionButton
        variant="search"
        icon={<SearchIcon sx={{ fontSize: 26 }} />}
        label="Rechercher"
        onClick={handleSearchClick}
      />
      <QuickActionButton
        variant="publish"
        icon={<AddIcon sx={{ fontSize: 26 }} />}
        label="Publier"
        onClick={handlePublishClick}
      />
    </Box>
  );
}
